import { deserialize, serialize, inheritSerialization } from "cerialize";

import BaseUUIDEntity from "./BaseUUIDEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";
import { getJenisKelamin, getPenerimaDana, getPengajian } from "../util/PluralVariabels";

@inheritSerialization(BaseUUIDEntity)
export default class Santri extends BaseUUIDEntity {

  @serialize
  @deserialize
  public nomor: string = "";

  @serialize
  @deserialize
  public nomor_induk: string = "";

  @serialize
  @deserialize
  public status: string = "";

  @serialize
  @deserialize
  public nama_lengkap: string = "";

  @serialize
  @deserialize
  public jenis_kelamin: string = "";

  @serialize
  @deserialize
  public tempat_tgl_lahir: string = "";

  @serialize
  @deserialize
  public tahun: string = "";

  @serialize
  @deserialize
  public wilayah: string = "";

  @serialize
  @deserialize
  public komplek: string = "";

  @serialize
  @deserialize
  public kamar: string = "";

  @serialize
  @deserialize
  public pengajian: string = "";

  @serialize
  @deserialize
  public pengajian_id: number | null = null;

  @serialize
  @deserialize
  public image: string = "";

  @serialize
  @deserialize
  public sekolah: string = "";

  @serialize
  @deserialize
  public tingkat: string = "";

  @serialize
  @deserialize
  public kelas: string = "";

  @serialize
  @deserialize
  public nik: string = "";

  @serialize
  @deserialize
  public orang_tua: string = "";

  @serialize
  @deserialize
  public nomor_telepon: string = "";

  @serialize
  @deserialize
  public alamat_lengkap: string = "";

  @serialize
  @deserialize
  public qr_code: string = "";

  public file: any = null;

  public table() {
    const {
      nomor, nama_lengkap, jenis_kelamin: jenis, sekolah, tingkat, kelas, pengajian: peng, wilayah, status
    } = this;
    const pondok = getPenerimaDana(wilayah);
    const pengajian = getPengajian(peng);
    const jenis_kelamin = getJenisKelamin(jenis);
    return {
      nomor, nama_lengkap, jenis_kelamin, pengajian, pondok, sekolah, tingkat, kelas, status
    };
  }

  public static columnName(): Array<TableColumn> {
    const table = new Santri().table();
    let keys = Object.keys(table);

    return keys.map((field: any, index: number) => {
      const tableColumn = new TableColumn();
      tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

      if (index > 4) {
        tableColumn.position = "centered";
      }
      return tableColumn;
    });
  }

  public fileFeedback() {
    return this.defaultPropertyFeedback("file");
  }

  public nomorFeedback() {
    return this.defaultPropertyFeedback("nomor");
  }

  public nikFeedback() {
    return this.defaultPropertyFeedback("nik");
  }

  public nomorIndukFeedback() {
    return this.defaultPropertyFeedback("nomor_induk");
  }

  public namaLengkapFeedback() {
    return this.defaultPropertyFeedback("nama_lengkap");
  }

  public tempatTanggalLahirFeedback() {
    return this.defaultPropertyFeedback("tempat_tgl_lahir");
  }

  public orangTuaFeedback() {
    return this.defaultPropertyFeedback("orang_tua");
  }

  public teleponFeedback() {
    return this.defaultPropertyFeedback("nomor_telepon");
  }

  public alamatFeedback() {
    return this.defaultPropertyFeedback("alamat_lengkap");
  }

  public komplekFeedback() {
    return this.defaultPropertyFeedback("komplek");
  }

  public kamarFeedback() {
    return this.defaultPropertyFeedback("kamar");
  }

  public tingkatFeedback() {
    return this.defaultPropertyFeedback("tingkat");
  }

  public kelasFeedback() {
    return this.defaultPropertyFeedback("kelas");
  }

  public resetProperty() {
    this.file = null;
  }

}
